// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('vdcpricing', {
    parent: 'main',
    url: '/vdc-pricing',
    views: {
      'main-content': {
        template: '<vdc-pricing></vdc-pricing>',
      },
    },
    data: { pageTitle: 'VDC Pricing' },
  });
};

angular.module('main.vdcPricing', []).config(config);
